import CallMadeIcon from '@mui/icons-material/CallMade';
import { Link } from 'react-router-dom';

export default function InterfaceHighlight( { icon = "", title, impact, date, summary, link, videoSrc } ){

    const sources = Array.isArray(videoSrc) ? videoSrc : (videoSrc ? [videoSrc] : []);

    return(
        <div>
            <div className = "page" style = { { paddingTop : "40px", paddingBottom : "28px" } } >
            
                <div style = { { display : "flex", flexDirection : "row", alignItems : "center", gap : "8px" } }>
                    {/* <img src = { icon } style = { { width : "28px", height : "28px", borderRadius : "8px", objectFit : "cover" } } /> */}
                    <Link to = { link } className = "footerLink">
                        <h3 style = { { fontSize : "var(--font-size-large)" } }>{ title }</h3>
                    </Link>
                    <div style = { { background : "var(--black56)", height : "1px", flex : 1, marginTop : "4px" } }/>
                </div>
                <p className = "meta2">{ date }</p>

                <p style={{ margin: 0, paddingTop : "24px" }}>
                    <span style={{ fontWeight: 500, color: "var(--black80)", marginRight : "4px", background : "var(--black4)", padding : "0px 4px" }}>{ impact }</span>
                    <span style={{ fontWeight: 400, color: "var(--black72)" }}>{summary}</span>
                </p>






                { sources.map( ( item, index ) => (
                    item.url.endsWith(".mp4") || item.url.endsWith(".mov") ? (
<div
  key={index}
  style={{ marginTop: "24px", overflow: "hidden", position: "relative", display: "inline-block", background : "var(--bg4)", borderRadius: "4px", border: "1px solid var(--black4)" }}
>

<video
className = "HomeVideo"
  src={item.url}
  style={{ display: "block", marginTop: item.full === false ? "7.5%" : "0%", marginLeft: item.full === false ? "7.5%" : "0%", width: "100%", height: "auto", borderRadius: "4px", }}
  autoPlay
  muted
  playsInline
  loop
/>


                    </div>
                    ) : (
                    <div key = { index } style = { { marginTop : "24px", aspectRatio: "16 / 9", overflow: "hidden", borderRadius : "4px", background : "var(--bg4)", border : "1px solid var(--bg4)" } }>
                        <img src = { item.url } style = { { width: "100%", borderRadius : "4px" } } />
                    </div>
                    )
                ))}
            
            </div>
        </div>
    )
}